<template>
  <div class="version"><span>v.220608</span></div>
</template>

<script>
export default {
  name: 'Version'
}
</script>

<style lang="scss">
    .version {
        margin: 0;
        padding: 0;
        padding-top: 50px;
        margin-top: auto;
        width: 100%;
        text-align: right;
        color: #f0f0f0;
    }
</style>